import { Controller } from '@hotwired/stimulus';

// The TVs online panel on a screen's page (docs/SCREENS.md § TVs online): a
// turbo-frame that reloads itself every few seconds, a morph of that frame
// alone, so the rest of the page (an open row menu) stays as it is. Hidden
// tab, no knock.
export default class extends Controller {
  static values = { every: { type: Number, default: 10 }, url: String };

  connect() {
    this.timer = setInterval(() => this.reload(), this.everyValue * 1000);
  }

  disconnect() {
    clearInterval(this.timer);
  }

  reload() {
    if (document.hidden) return;
    if (this.element.src) this.element.reload();
    else this.element.src = this.urlValue;
  }
}
